// src/components/IDE/ide/core/bridge.ts
import type { EngineBridge } from './types';

/** No-op bridge totalement générique (aucun nom de méthode connu côté IDE). */
export function makeNoopBridge(logger: (m: any) => void = console.warn): EngineBridge {
  const handler: ProxyHandler<any> = {
    get(_target, prop) {
      // ✅ Ne pas faker .events: ainsi hasBridgeEvents(...) restera false
      if (prop === 'events') return {}; // ou `undefined` si tu préfères

      // Noop générique, log sur tout appel
      const fn = () => { };
      return new Proxy(fn, {
        apply(_fn, _thisArg, args) {
          logger?.(`[EngineBridge:NOOP] call ${String(prop)}(${args?.length ?? 0} args) ignored`);
          return undefined;
        },
        get() {
          // chainable noops — mais on évite de recréer des "on/off" fonctionnels
          return new Proxy(() => { }, this as any);
        },
      });
    },
  };
  return new Proxy({}, handler) as EngineBridge;
}

/** Récupère un bridge exposé par window[key]. Fallback: noop. */
export function createWindowBridge(key = '__IDE_BRIDGE__', logger: (m: any) => void = console.warn): EngineBridge {
  const anyWin = window as any;
  const candidate = anyWin?.[key];
  if (candidate && (typeof candidate === 'object' || typeof candidate === 'function')) return candidate as EngineBridge;
  return makeNoopBridge(logger);
}
